import { Box } from "@mui/material";
import { Card, spacing } from "@procore/core-react";

import { useAppSelector } from "app/redux-store-interactions";
import { selectPeekAllRedo, selectPeekAllUndo } from "features/undoRedo";

const SHOW_VISUALIZER = false;

// Visualizer for the undo/redo stack for debugging purposes
export const UndoRedoStackVisualizer = () => {
    const undoActions = useAppSelector(selectPeekAllUndo);
    const redoActions = useAppSelector(selectPeekAllRedo);

    if (!SHOW_VISUALIZER) {
        return null;
    }

    return (
        <Box style={{ position: "absolute", bottom: 8, left: 8 }}>
            <Card>
                <Box padding={spacing.xxs}>
                    <h3>Undo Stack</h3>
                    {undoActions
                        .slice()
                        .reverse()
                        .map((action, i) => (
                            <Card key={i}>{action.description}</Card>
                        ))}
                    <h3>Redo Stack</h3>
                    {redoActions
                        .slice()
                        .reverse()
                        .map((action, i) => (
                            <Card key={i}>{action.description}</Card>
                        ))}
                </Box>
            </Card>
        </Box>
    );
};
